import React from "react";
import PropTypes from "prop-types";
import { FluentDialog2 } from "../../../../components/FluentUI/Fluent-Dialog2";
import FluentUiIcon from "../../../../assets/fluent-ui-icon";
import { FluentButton } from "../../../../components/FluentUI/Fluent-Button";

export const AutoPopulateDialog = ({ open, OnCancel, OnSave }) => {
  return (
    <FluentDialog2 open={open}>
      <div className="task-type-dialog-title">
        <p>{`Re-trigger Auto-populate for this Form? Data will be Overwritten`}</p>
        <p onClick={OnCancel}>
          <FluentUiIcon name={"DismissRegular"} color={"#212121"} size={20} />
        </p>
      </div>
      <div className="task-type-dialog-content">
        <p>{`‘Auto-populate’ was previously used to populate certain Fields within this Form. Re-triggering ‘Auto-populate’ 
        will overwrite any data that was previously fetched via API connections with new information. `}</p>
        <p>
          {`If one/more auto-populated Form Fields were previously edited with manual input, 
          any Unsaved overrides will be irreversibly lost.`}
        </p>
      </div>
      <div className="task-type-dialog-footer">
        <FluentButton
          onClick={OnCancel}
          text={"Cancel"}
          backgroundColor={"#0F6CBD"}
        />
        <FluentButton
          onClick={OnSave}
          appearance="primary"
          text="Auto-populate"
          backgroundColor={"#0F6CBD"}
        />
      </div>
    </FluentDialog2>
  );
};

AutoPopulateDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  OnCancel: PropTypes.func.isRequired,
  OnSave: PropTypes.func.isRequired,
};
